import { MenuItemType } from '../Types/Menu';

const API = {
	/** Путь для получения навигационного меню */
	GET: '/Nvx.ReDoc.WebInterfaceModule/Controller/MainPageController/NavigationMenu',
};

export default class Menu {
	/** Получение списка доступных меню */
	static getMainMenu: () => Promise<MenuItemType[]> = async () => {
		const url = window.host + API.GET;
		try {
			const request = await fetch(url, { credentials: 'include' });
			if (request.status === 200) {
				return await request.json();
			}
			throw new Error('Ошибка при получении меню.');
		} catch (e: any) {
			console.warn(e);
			throw new Error('Ошибка при получении меню', e);
		}
	};
}
